<template>
    <div v-if="showMyVip" class="my-vip-page layout-sub-page" :class="{'my-vip-page-1': curVipPayType <= 4, 'my-vip-page-2': curVipPayType > 4}">
        <!-- 标题栏 -->
        <div class="my-vip-title-bar">
            <div class="my-vip-t-back" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></div>
            <div v-if="curVipPayType <= 4" class="my-vip-title title1"></div>
            <div v-else class="my-vip-title title2"></div>
        </div>
        <div class="my-vip-information" v-if="parseInt(userData.vip) == 0">
            <p>成为VIP你将享用更多的特权，可享受以下功能特权，</p>
            <p>更多特权敬请关注！</p>
        </div>
        <div class="my-vip-information" v-else-if="parseInt(userData.vip) == 10">
            <p>你是尊贵的月VIP会员，可享受以下功能特权，</p>
            <p>升级成为年会员你将获得更多特权。</p>
        </div>
        <div class="my-vip-information" v-else-if="parseInt(userData.vip) == 20">
            <p>你是尊贵的年VIP会员，可享受以下功能特权，</p>
            <p>升级成为终身会员你将获得更多特权。</p>
        </div>
        <div class="my-vip-information" v-else-if="parseInt(userData.vip) == 30">
            <p>您是尊贵的终身VIP会员，</p>
            <p>可享受以下功能特权，更多特权敬请关注！</p>
        </div>

        <!-- 列表部分 -->
        <div class="my-vip-content-box">
            <div class="my-vip-content" :class="{'vip1': curSelectPayType <= 10, 'vip2': curSelectPayType == 20, 'vip3': curSelectPayType == 30}"></div>
        </div>
        <!-- 弹框部分: 终身会员 -->
        <div class="my-vip-bottom-pop pop1" v-if="curVipPayType == 2 && parseInt(userData.vip) != 30">
            <div class="my-vip-bottom-list clearfix" :class="'my-vip-bottom-list'+parseInt(userData.vip)">
                <div class="my-vip-bottom-l-item" :class="{'selected': curSelectPayType <= 10}" v-if="parseInt(userData.vip) == 0" @click="selectItem(10)">
                    <p class="p1">月会员</p>
                    <p class="p2">￥<span class="num">{{vipProductData["pay_40000"] ? vipProductData["pay_40000"].price : ''}}</span>元</p>
                    <p class="p3"></p>
                    <div class="item-note" v-if="curSelectPayType == 10"></div>
                    <div class="item-select" v-if="curSelectPayType == 10"></div>
                </div>
                <div class="my-vip-bottom-l-item" :class="{'selected': curSelectPayType == 20}" v-if="parseInt(userData.vip) <= 10" @click="selectItem(20)">
                    <p class="p1">年会员</p>
                    <p class="p2">￥<span class="num">{{vipProductData["pay_40001"] ? vipProductData["pay_40001"].price:''}}</span>元</p>
                    <p class="p3">{{vipProductData["pay_40001"] ? parseInt(vipProductData["pay_40001"].price/12)+'元/月' : ''}}</p>
                    <div class="item-note" v-if="curSelectPayType == 20"></div>
                    <div class="item-select" v-if="curSelectPayType == 20"></div>
                </div>
                <div class="my-vip-bottom-l-item" :class="{'selected': curSelectPayType == 30}" v-if="parseInt(userData.vip) <= 20" @click="selectItem(30)">
                    <p class="p1">终身会员</p>
                    <p class="p2">￥<span class="num">{{vipProductData["pay_40002"] ? vipProductData["pay_40002"].price : ''}}</span>元</p>
                    <p class="p3">6.1元/月</p>
                    <div class="item-note" v-if="curSelectPayType == 30"></div>
                    <div class="item-select" v-if="curSelectPayType == 30"></div>
                </div>
            </div>
            <div class="my-vip-bottom-sub-note">
                <p>成为会员，享受更多特权</p>
            </div>
            <div class="my-vbp-button" @click="clickUse">继续</div>
        </div>
        <div class="my-vip-bottom-pop pop22" v-if="curVipPayType == 3">
            <div class="my-vbp-text-22 dsp-flex">
                <div class="my-vbp-text-22-l">优惠名额仅剩<span v-if="curVipShowTime != 0" class="num">{{vipActivityInfo['day'+curVipShowTime]}}</span>位</div>
                <div class="my-vbp-text-22-r"><span class="text">支付剩余时间</span><span class="time">{{timeArr[0]}}</span><span class="quote">:</span><span class="time">{{timeArr[1]}}</span></div>
            </div>
            <div class="my-vbp-button button2" @click="clickUse">早买早享受，马上体验</div>
        </div>
        <div class="my-vip-bottom-pop pop33" v-if="curVipPayType == 4">
            <div class="my-vbp-text-22 text-33 dsp-flex">
                <div class="my-vbp-text-22-l">优惠名额仅剩<span v-if="curVipShowTime != 0" class="num">{{vipActivityInfo['day'+curVipShowTime]}}</span>位</div>
                <div class="my-vbp-text-22-r"><span class="text">支付剩余时间</span><span class="time">{{timeArr[0]}}</span><span class="quote">:</span><span class="time">{{timeArr[1]}}</span></div>
            </div>
            <div class="my-vbp-button button33" @click="clickUse"></div>
        </div>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
import { DOM } from '../../modules/dom';
export default {
    name: 'MyVip',
    components: { },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        showMyVip() {
            return this.$store.state.user.showMyVip;
        },
        curVipPayType() {
            return this.$store.state.user.curVipPayType;
        },
        curSelectPayType() {
            return this.$store.state.user.curSelectPayType;
        },
        vipActivityInfo() {
            return this.$store.state.user.vipActivityInfo
        },
        vipProductData() {
            return this.$store.state.pay.vipProductData;
        },
        vipCountTime() {
            return this.$store.state.reminder.vipCountTime
        },
        startVipCount() {
            return this.$store.state.reminder.startVipCount
        },
        curVipShowTime() {
            return this.$store.state.reminder.curVipShowTime
        },
    },
    data() {
        return {
            timeArr: ['00', '00'],
            timeFunc: undefined
        }
    },
    mounted() {
        this.$bus.on('initMyVipPage', this.initDom);
        this.$bus.on('startMyVipAni', this.startAni);
    },
    destroyed() {
        this.clearAni();
        this.$bus.off('initMyVipPage', this.initDom);
        this.$bus.off('startMyVipAni', this.startAni);
    },
    methods: {
        initDom() {
            this.$el.style.height = innerHeight+'px';
            var titleDom = document.getElementsByClassName('my-vip-title-bar')[0],
                contDom = document.getElementsByClassName('my-vip-content-box')[0],
                popDom = document.getElementsByClassName('my-vip-bottom-pop')[0];
            var height = innerHeight;
                height = titleDom ? height-titleDom.clientHeight : height;
                height = popDom ? height-popDom.clientHeight : height;
            if(contDom){
                contDom.style.height = (height-48)+'px';
            }
        },
        clickBack() {
            this.$store.state.user.showMyVip = false;
            this.$store.state.user.curVipPayType = 2;
            this.$store.state.reminder.showDownloadReminder = true;
            this.clearAni();
            
            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('report') != -1) {
                // DOM.showParentPageByClassName('report-page');
            }else if(curPath.indexOf('nature') != -1) {
                DOM.showParentPageByClassName('nature-page');
            }
        },
        clickUse() {
            var me = this,
                pId = this.curSelectPayType == 10 ? 'pay_40000' : this.curSelectPayType == 20 ? 'pay_40001' : 'pay_40002',
                pData = this.vipProductData[pId],
                curPath = this.$router.history.current.path,
                detailInfo = this.$store.state.detail.personInfo;
            console.log('clickUse-----', curPath, pData, detailInfo);
            MIX.trackButtonClicked('to_be_vip_continue');
            
            if(curPath.indexOf('embedded') != -1) {
                SCHEME.createAppOrder(pData.pid, detailInfo.id);
                // 支付成功和失败的回调:::app端的回调函数
                window.appFunc = {};
                window.appFunc.reportPaySucCb = function(data) {
                    console.log('reportPaySucCb::::::::', data)
                    // data = JSON.stringify(data);
                    if(detailInfo) {
                        me.$store.dispatch('report/updateReportInfo', data.baziId);
                    }
                    // 隐藏支付弹框,显示成功弹框
                    me.$store.state.report.showVipBtn = false;
                    me.$store.state.user.showMyVip = false;
                    me.$store.state.user.showVipSucPop = true;
                }
                window.appFunc.reportPayFailCb = function() {
                    console.error("支付失败");
                    // me.$toast('支付失败,请稍后再尝试~')
                }
                return;
            }

            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: pData.pid,
                    ptype: pData.payType[2],
                    discount: CONFIG.vip_discount
                },
                mixParams: {
                    pid: pData.pid,
                    product_name: pData.title,
                    price: pData.price,
                    from: 'my_vip',
                },
                sucCb: function() {
                    console.log('支付VIP成功');
                    // 更新数据
                    if(detailInfo) {
                        if(curPath.indexOf('report') != -1) {
                            me.$store.dispatch('report/updateReportInfo', detailInfo.id);
                        }else if(curPath.indexOf('nature') != -1) {
                            me.$store.dispatch('report/getAiCharacter', {
                                detailInfo: detailInfo
                            });
                        }
                    }
                    // 隐藏支付弹框,显示成功弹框
                    me.$store.state.user.showMyVip = false;
                    me.$store.state.user.showVipSucPop = true;
                    me.$set(me.$store.state.userData, 'vip', me.curSelectPayType);
                    me.$set(me.$store.state.userData.info, 'vip', me.curSelectPayType);
                    me.$store.state.user.curSelectPayType = me.curSelectPayType == 10 ? 20 : 30;
                    me.$bus.emit('updateMyVipInfo');
                },
                failCb: function() {
                    console.error('支付失败----')
                    // me.$toast('支付失败,请稍后再尝试~')
                }
            });
        },
        startAni() {
            console.error('startAni', this.vipCountTime)
            var me = this, 
                lsTime = localStorage.getItem('h5_vip_count_time'),
                startTime = 0;
            if(me.timeFunc) { clearTimeout(me.timeFunc) };
            if(this.startVipCount) {
                startTime = this.vipCountTime != 0 ? this.vipCountTime : startTime;
            }else {
                startTime = lsTime && parseInt(lsTime) != 0 ? parseInt(lsTime) : startTime;
            }
            console.error('startTime------', this.startVipCount, startTime, lsTime)
            this.$store.state.reminder.startVipCount = false;
            function count() {
                me.timeArr = UTILS.getTimeArrBySecond(startTime);
                // console.error('count-----', me.timeArr)
                if(startTime == 0) {
                    me.timeArr = ['00', '00'];
                    me.$store.state.reminder.showVipPop = false;
                    me.$store.state.user.curVipPayType = 2;
                    clearTimeout(me.timeFunc);
                }else {
                    startTime--;
                    window.localStorage.setItem('h5_vip_count_time', startTime);
                    me.timeFunc = setTimeout(() => {
                        count();
                    }, 1000);
                }
            }
            if(startTime == 0) { return; }
            count();
        },
        clearAni() {
            clearTimeout(this.timeFunc);
        },
        selectItem(type) {
            switch(type){
                case 10:
                    MIX.trackButtonClicked('to_be_vip_tab_month');
                    break;
                case 20:
                    MIX.trackButtonClicked('to_be_vip_tab_year');
                    break;
                case 30:
                    MIX.trackButtonClicked('to_be_vip_tab_forever');
                    break;
                default:
                    break;
            }
            this.$store.state.user.curSelectPayType = type;
        }
    }
}
</script>